import { ReactNode } from "react";
import cryptoLogos from "../../assets/logos/crypto.png";
import euroLogo from "../../assets/logos/euro.png";
import interacLogo from "../../assets/logos/interac.png";
import pixLogo from "../../assets/logos/pix.png";
import qrphLogo from "../../assets/logos/qrph.png";

interface ExchangeInfoPanelProps {
  headline: ReactNode;
}

const PAYMENT_METHODS = [
  { label: "Open Banking", logo: euroLogo },
  { label: "PIX", logo: pixLogo },
  { label: "QR Ph", logo: qrphLogo },
  { label: "Interac", logo: interacLogo },
];

function ExchangeInfoPanel({ headline }: ExchangeInfoPanelProps) {
  return (
    <>
      <div className="flex flex-col items-center lg:hidden w-full mb-[8px] shrink-0">
        <div className="inline-flex items-center px-[12px] py-[6px] rounded-full border border-[#1418A8] text-[#1418A8] text-[12px] font-normal tracking-[0.04em]">
          TYLT EXCHANGE
        </div>
        <h1 className="mt-[16px] text-[20px] leading-[1.2] font-normal text-text-base">
          {headline}
        </h1>
      </div>

      <div className="hidden lg:flex flex-col justify-between w-full max-w-[580px] pr-[40px] py-[20px] shrink-0">
        <div>
          <div className="inline-flex items-center px-[12px] py-[6px] rounded-full border border-[#1418A8] text-[#1418A8] text-[14px] font-normal tracking-[0.04em]">
            TYLT EXCHANGE
          </div>

          <h1 className="mt-[36px] text-[50px] leading-[1.15] font-normal text-text-base">
            {headline}
          </h1>

          <div className="mt-[36px] flex items-center gap-[12px]">
            <div className="flex items-center">
              <img
                src={cryptoLogos}
                alt="crypto logos"
                className="w-full h-auto"
              />
            </div>
            <p className="text-text-subtle text-[12px]">
              <span className="font-normal text-text-base text-[18px]">
                + many more
              </span>
              <br />
              supported tokens & networks
            </p>
          </div>

          <div className="mt-[36px] flex flex-wrap gap-[8px]">
            {PAYMENT_METHODS.map((method) => (
              <div
                key={method.label}
                className="inline-flex items-center gap-[6px] px-[12px] py-[7px] rounded-full border border-[#1418A8] bg-transparent text-[11px] font-medium text-[#4315B6]"
              >
                <img
                  src={method.logo}
                  alt={method.label}
                  className="w-[14px] h-[14px] rounded-full"
                />
                {method.label}
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-[16px] bg-bg-page-body border border-border-subtle px-3 py-4 shadow-sm">
          <h2 className="text-text-base text-[14px] font-bold mb-[12px]">
            Secure Purchase
          </h2>
          <div className="space-y-[12px]">
            <div>
              <p className="text-[#1418A8] text-[10px] font-semibold">
                Buy with Confidence
              </p>
              <p className="text-text-subtle text-[10px] mt-[4px] leading-[1.45]">
                Review your exchange rate, fees and full transaction summary
                before you confirm your payment.
              </p>
            </div>
            <div>
              <p className="text-[#1418A8] text-[10px] font-semibold">
                Quick and simple verification
              </p>
              <p className="text-text-subtle text-[10px] mt-[4px] leading-[1.45]">
                Get started with minimal verification for purchases up to CAD
                1,000. For higher amounts, a quick government ID check helps keep
                your transactions secure.
              </p>
            </div>
            <div>
              <p className="text-[#1418A8] text-[10px] font-semibold">
                Secure from start to finish
              </p>
              <p className="text-text-subtle text-[10px] mt-[4px] leading-[1.45]">
                Every purchase is protected by AML, sanctions, Travel Rule and
                wallet-screening checks, so you can buy crypto with greater peace
                of mind.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExchangeInfoPanel;
